import Vue from 'vue';
import { MutationTree } from 'vuex';
import { PostGradMicrocertificateState } from './state';

const mutations: MutationTree<PostGradMicrocertificateState> = {
  SET_POSTGRAD_MICROCERTIFICATE_ELIGIBILITY(
    state,
    payload: { disciplinesMicrocertificateEligibility: boolean; classroomId: number },
  ) {
    const { disciplinesMicrocertificateEligibility, classroomId } = payload;
    if (!classroomId) return;
    Vue.set(
      state.disciplinesMicrocertificateEligibility,
      classroomId.toString(),
      disciplinesMicrocertificateEligibility,
    );
  },
};

export default mutations;
